import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/rob/rob.sss';
import Store from 'store/store';
import { smoothScrollTo } from 'utils/smoothScroll';
import { glyphs } from 'helpers/airportData';
import { getDateNum } from 'utils/querySimulation';
import { list, idIndex, expressions, expressionKey } from 'helpers/robData.js';
export default class Rob extends Component {
	constructor(props) {
		super(props);
		this.props = props;
		this.copy = this.props.copy;
		this.imageRoot = this.props.imageRoot;
		this.state = {
			chatOpen: false,
			glowing: false,
			area: 'homepage',
			chatNum: 0,
			dateNum: 0,
			animLength: -1,
			sentenceLength: 0,
			animatingQuestion: true,
			isTyping: true,
			typingLoopNum: 0,
			inputText: '',
			doBarrelRoll: false
		};

		this.order = [],
		this.inputs = [],
		this.lastArea = 'homepage';
		this.lastChatNum = 0;
		this.renderChat = this.renderChat.bind(this);

		this.onCloseClick = this.onCloseClick.bind(this);
		this.handleResponseClick = this.handleResponseClick.bind(this);
		this.resetAnimation = this.resetAnimation.bind(this);
		this.resetChat = this.resetChat.bind(this);
		this.updateOrder = this.updateOrder.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.clearChat = this.clearChat.bind(this);
		this.barrelRollComplete = this.barrelRollComplete.bind(this);

		this.glyphs = glyphs.filter(s => !s.disabled);
	}

	componentDidMount() {
		let dateNum = getDateNum();
		if (dateNum) {
			this.setState({ dateNum: dateNum || '0' });
		}

		Store.on('ROB_UPDATE', (data) => {
			if (data.split('_')[1] == 'closed' || data == 'clear') {	
				if (data.split('_')[0] == this.state.area) {
					this.clearChat();
				}
			} else {
				const { chatOpen } = this.state;
				const area = list[data.split('_')[0]] ? data.split('_')[0] : undefined;
				if (area) {
					const functionality = list[area]?.functionality;
					if (area == 'homepage' && this.lastArea != 'upWorld' && this.lastArea != 'downWorld' && this.lastArea != 'homepage') {
						return;
					}
					let chatNum = functionality == 'updatesByDate' ? this.state.dateNum : idIndex[data] ? idIndex[data].id : this.state.chatNum;
					this.setState({ area: area, chatNum: chatNum });

					if (area != this.lastArea) {
						this.lastArea = area;
						this.resetChat();
					} else {
						if (functionality == 'unordered') {
							this.order.push(chatNum);
						}
					}
					if (idIndex[data]) { 
						idIndex[data].shown = true;
					}

					if (chatOpen) {
						list[area].shown = true;
						Store.emit('CUSTOM_EVENT', {
							category: 'rob',
							action: 'rob-expansion-view',
							label: area
						});
					} else {
						this.setState({ glowing: list[area].shown ? false : true });
						if (!list[area].shown ) {
							Store.emit('PLAY_SOUND', 'robNotification');
						}
					}

					if (area == 'downWorld' || area == 'glyph' || area == 'boomerang') {
						this.toggleChat(true);
						list[area].shown = true;
						Store.emit('CUSTOM_EVENT', {
							category: 'rob',
							action: 'rob-expansion-view',
							label: area
						});
					}
					if (functionality == 'unordered') {
						if (this.$messages) {
							smoothScrollTo(this.$messages, this.$messages.scrollHeight, this.$messages.scrollHeight );
						}
					}
				}
			}
		});
	}

	onCloseClick(e) {
		e.stopPropagation();
		this.toggleChat(false);
	}

	toggleChat(bool) {
		const { area, chatOpen } = this.state;
		if (!!bool === !!chatOpen) return;
		Store.emit('PLAY_SOUND', 'robToggle');
		if (area) {
			list[area].shown = true;
			Store.emit('CUSTOM_EVENT', {
				category: 'rob',
				action: 'rob-expansion-view',
				label: area
			});
		}
		this.setState({ chatOpen: bool, glowing: false });
	
		setTimeout(() => {
			if (this.$messages) {
				smoothScrollTo(this.$messages, this.$messages.scrollHeight, this.$messages.scrollHeight);
			}	
		}, 1000);
	
	}

	clearChat() {
		this.order = [];
		this.setState({ area: 'homepage', chatNum: 0 });
		this.toggleChat(false);
		this.setState({ glowing: false });
	}

	handleResponseClick(e, resp, respIndex) {
		e.stopPropagation();
		const { area, chatNum } = this.state;
		const numOfQuestions = Object.keys(this.copy.$ROB[area]).length;
		const buttonDestination = list[area]?.buttonDestination[chatNum];
		if (!buttonDestination) {
			return;
		}

		if (buttonDestination == 'destinations') {
			Store.emit('UPDATE_PLANET_OVERLAY', resp.id);
		} else if (buttonDestination == 'close') {
			this.clearChat();
		} else if (buttonDestination == 'airport') {
			Store.emit('RESET_SCROLL', 'smooth' ); 
		} else if (buttonDestination == 'leaveDownWorld') {
			Store.emit('PLAY_BRICKS_VIDEO');
		} else if (buttonDestination == 'ticketSite') { 	
			// if (respIndex == 0) {
			// 	window.open(this.copy.$showtimesLink);
			// 	Store.emit('CUSTOM_EVENT', {
			// 		category: 'up-world',
			// 		action: 'watch-click',
			// 		label: 'bookNow'
			// 	});
			// } else if (respIndex == 1) {
			// }
			Store.emit('CUSTOM_EVENT', {
				category: 'up-world',
				action: 'watch-click',
				label: 'homeEnt'
			});
			if (this.copy.$watchAtHome == '' || !this.copy.$watchAtHome) {
				window.open(this.copy.$watchAtHomeLink);
			} else {
				Store.emit('RESET_SCROLL', 'smooth' ); 
				setTimeout(() => {
					Store.emit('OPEN_WATCH_AT_HOME', 'watchAtHome');
				}, 1500);		
			}
		} else if (buttonDestination == 'nextQuestion') { 
			if (chatNum + 1 < numOfQuestions) {
				this.setState({ chatNum: chatNum + 1 });
			}
		}
	}

	resetChat() {
		const { area, chatNum } = this.state;		
		const functionality = list[area].functionality;
		this.order = [];

		if (functionality == 'default' || functionality == 'timeDelayed') {
			this.setState({ chatNum: 0 });
		} if (functionality == 'timeDelayed' ) {
			this.setState({ chatNum: 0 });
			setTimeout(() => {
				if (list[this.state.area].functionality == 'timeDelayed' && this.state.chatNum == 0) {
					this.setState({ chatNum: 1 });
				}
			}, 3000);
		} else if (functionality == 'updatesByDate') {
			this.order.push(chatNum);
		} else if (functionality == 'unordered') {
			this.order.push(0);
		} else if (functionality == 'input') {
			this.order.push(0);
			this.inputs = [];
		}
		Object.values(idIndex).map(id => {
			id.shown = false;
		});
		this.resetAnimation();
	}

	resetAnimation() {
		this.setState({ animLength: -1, animatingQuestion: true, isTyping: true, typingLoopNum: 0 });
		if (this.$messages) {
			smoothScrollTo(this.$messages, this.$messages.scrollHeight, this.$messages.scrollHeight );
		}
	}

	updateAnimation() {
		const { area, chatNum, animLength, animatingQuestion, isTyping, typingLoopNum } = this.state;
		if (animatingQuestion) {
			const currentCopy = this.copy.$ROB[area]?.[chatNum];
			const sentence = isTyping ? '...' : currentCopy['question'];
			const sentenceLength = sentence.length;
			let char = sentence.slice(animLength - 1, animLength);

			setTimeout(() => {
				const { animLength } = this.state;
				if (animLength >= sentenceLength) {
					if (isTyping) {
						if (typingLoopNum > 0) {
							this.setState({ animLength: 0, isTyping: false });
						} else {
							this.setState({ animLength: 0, typingLoopNum: typingLoopNum + 1 });
						}
						
					} else {
						this.setState({ animLength: 0, animatingQuestion: false });
					}			
					
					if (this.$messages) {
						smoothScrollTo(this.$messages, this.$messages.scrollHeight, this.$messages.scrollHeight );
					}
				} else {
					this.setState({ animLength: animLength + 1 });
				}
			}, char == '…' ? 1500 : isTyping ? 250 : 50 );
		}
	}

	updateOrder() {
		const { area, chatNum } = this.state;
		const functionality = list[area].functionality;

		if (functionality == 'default' || functionality == 'timeDelayed') {
			this.order = [];
			for (let i = 0; i < (parseInt(chatNum) + 1); i++ ) {
				this.order.push(i);
			}
		}
	}

	handleSubmit (e) {
		e.preventDefault();
		const { inputText } = this.state;
		if (inputText.length > 0) {
			this.inputs.push(inputText);

			const correctCode = this.glyphs.find((glyph) => glyph.name.toLowerCase() === inputText.toLowerCase());

			if (correctCode) {
				Store.emit('CUSTOM_EVENT', {
					category: 'glyph-reveal',
					action: 'successful-code-input',
					label: correctCode.id
				});
				if (correctCode.easterEgg) {
					Store.emit('OPEN_EASTER_EGG', correctCode.id); 
					this.order.push(1);
					this.setState({ chatNum: 1 });
				} else if (correctCode.barrelRoll) {
					this.toggleChat(false);
					this.setState({ doBarrelRoll: true });
					Store.emit('PLAY_SOUND', 'barrelRoll');
					this.order.push(3);
					this.setState({ chatNum: 3 });
				}
			} else {
				this.order.push(2);
				this.setState({ chatNum: 2 });
			}

			if (this.$messages) {
				smoothScrollTo(this.$messages, this.$messages.scrollHeight, this.$messages.scrollHeight );
			}
			e.target.reset();
			this.setState({ inputText: '' });
		}
	}

	barrelRollComplete() {
		this.setState({ doBarrelRoll: false });
		this.toggleChat(true);
	}

	renderChat() {
		const { area, chatNum, animLength, animatingQuestion, isTyping } = this.state;
		let functionality;
		if (area) {
			functionality = list[area].functionality;
			if (chatNum != this.lastChatNum) {
				this.lastChatNum = chatNum;
				this.resetAnimation();
			}
			this.updateAnimation();
			this.updateOrder();
		}

		return (
			<div class={s.chat}>
				<div class={s.messages} ref={ref => this.$messages = ref}>
					{Object.values(this.order).map((chatNum, index) => {
						const isLastChat = this.order.length - 1 == index;
						const animating = animatingQuestion && isLastChat ? true : false;
						const show = area && isTyping && isLastChat ? false : true;
						let question = this.copy.$ROB[area]?.[chatNum]?.['question'];
						question = question.slice(0, animating ? animLength : question.length );
						if (functionality == 'input') {
							return (
								<div class={s.messageSection}>
									<div class={joinClasses(s.question, show && s.show)}>{question}</div>
									{this.inputs[index] && (
										<button
											class={joinClasses(s.response, s.chosen, s.show )}
											onClick={(e) => this.handleResponseClick(e, this.inputs[index])}
										>
											{this.inputs[index]}
										</button>
									)}
								</div>
							);
						} else {
							return (
								<div class={s.messageSection}>
									<div class={joinClasses(s.question, show && s.show)}>{question}</div>
									{this.copy.$ROB[area]?.[chatNum]?.['response'] != undefined && 	
										Object.values(this.copy.$ROB[area]?.[chatNum]?.['response']).map((response, responseIndex) => {
											if (!response) {
												return;
											}
											const chosen = index + 1 < this.order.length; 
											const show = !animatingQuestion || chosen; 
											return (
												<button
													class={joinClasses(s.response, chosen && s.chosen, show && s.show, s.clickable)}
													onClick={(e) => this.handleResponseClick(e, response, responseIndex)}
												>
													{response.label || response}
												</button>
											);
										})
									}
								</div>
							);
						}
					})}
				</div>
				{isTyping && area && 
					<div class={s.typing}><p>{'...'.slice(0, animLength)}</p></div>
				}
				{functionality == 'input' && (
					<form class={s.form} onSubmit={this.handleSubmit}>
						<input class={s.input} type="text" placeholder={this.copy.$ROB.inputPlaceholder} onInput={(e) => this.setState({ inputText:  e.target.value })} />
						<button class={s.submit} type="submit">
							<img src={`${this.imageRoot}/chat/w9p6iv.svg`} />
						</button>
					</form>
				)}
			</div>
		);
	}

	render({ imageRoot, client }) {
		const { chatOpen, glowing, area, animatingQuestion, doBarrelRoll } = this.state;

		let height;
		let msgHeight = 0;

		if (this.$messages && this.$messages.lastElementChild) {
			msgHeight = this.$messages.lastElementChild.getBoundingClientRect().height;
		}
		height = chatOpen ? area == 'glyph' ? 280 : msgHeight + 40 > 209 && !animatingQuestion ? msgHeight + 40 : client?.isDesktopWidth ? 209 : 280 : client?.isDesktopWidth ? 95 : 52;
		let style = { height: `${height}px` };


		// let currentExpression = 'neutral';
		// if (area && chatNum && expressionKey[area][chatNum].question) {
		// 	currentExpression = !animatingQuestion && expressionKey[area][chatNum].response ? expressionKey[area][chatNum].response : expressionKey[area][chatNum].question; 
		// }
 
		return (
			<div class={joinClasses(s.animContainer, doBarrelRoll && s.barrelRoll)} onAnimationEnd={() => this.barrelRollComplete()}>
				<div class={joinClasses(s.container, chatOpen && s.open, glowing && s.glowing, doBarrelRoll && s.barrelRollInner)} style={style} onClick={() => !chatOpen && this.toggleChat(true)}>
					<div class={s.glow} />
					{chatOpen && this.renderChat()}
					<img class={s.rob} src={`${this.imageRoot}/chat/fbjxdu.webp`} alt={this.copy.$altRob} id={'clickable'} />
					<img class={joinClasses(s.notification, glowing && s.show )} src={`${imageRoot}/chat/mo8jgo.webp`} />
					<button class={s.closeBtn} onClick={this.onCloseClick}>
						<img class={s.closeBtnImg} src={`${imageRoot}/closebtn.webp`} />
						<img class={s.hoverCloseBtnImg} src={`${imageRoot}/hjmp3s.webp`} />
					</button>
				</div>
			</div>
		);
	}

}